"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = exports.TitleTextPropTypes = exports.PricePropTypes = exports.ImagePropTypes = exports.FilterPropTypes = exports.FilterOptionsPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var TitleTextPropTypes = _propTypes["default"].shape({
  title: _propTypes["default"].string,
  text: _propTypes["default"].string
});
exports.TitleTextPropTypes = TitleTextPropTypes;
var ImagePropTypes = _propTypes["default"].shape({
  altText: _propTypes["default"].string,
  image: _propTypes["default"].string
});
exports.ImagePropTypes = ImagePropTypes;
var PricePropTypes = _propTypes["default"].shape({
  label: _propTypes["default"].string,
  value: _propTypes["default"].number,
  displayValue: _propTypes["default"].string
});
exports.PricePropTypes = PricePropTypes;
var FilterOptionsPropTypes = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  image: ImagePropTypes,
  price: PricePropTypes,
  titleAndText: TitleTextPropTypes,
  selected: _propTypes["default"].bool
});
exports.FilterOptionsPropTypes = FilterOptionsPropTypes;
var FilterPropTypes = _propTypes["default"].shape({
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  filteringOptions: _propTypes["default"].arrayOf(FilterOptionsPropTypes)
});
exports.FilterPropTypes = FilterPropTypes;
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  label: _propTypes["default"].string,
  titleAndText: TitleTextPropTypes,
  filter: FilterPropTypes
});
var _default = PROP_TYPES;
exports["default"] = _default;